import React from 'react';
import { css } from 'emotion';
import classnames from 'classnames';

const floatLeft = css({
  label: 'left',
  float: 'left'
});

const floatRight = css({
  label: 'right',
  float: 'right'
});

const FloatBox = ({left, right, children, className}) => {
    const classes = classnames(className, {
      [floatLeft]: left,
      [floatRight]: right,
    });

    return (
      <div className={classes}>
        {children}
      </div>
    );
};

export default FloatBox;



// WEBPACK FOOTER //
// ./src/components/floatbox/floatbox.js